(() => {
  const setup = () => {
    document.querySelectorAll('[data-newsletter-animation]').forEach((panel) => {
      if (panel.dataset.animationReady) return;
      const image = panel.querySelector('[data-newsletter-image]');
      if (!image) return;
      panel.dataset.animationReady = 'true';
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activated = !('IntersectionObserver' in window);
      const reconcile = () => {
        const src = activated && !preference.matches ? image.dataset.animatedSrc : image.dataset.stillSrc;
        if (image.getAttribute('src') !== src) image.src = src;
      };
      const observer = activated ? null : new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        activated = true;
        reconcile();
        observer.disconnect();
      }, { rootMargin: '300px' });
      observer?.observe(panel);
      preference.addEventListener('change', reconcile);
      panel.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        preference.removeEventListener('change', reconcile);
        observer?.disconnect();
      }, { once: true });
      reconcile();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
